module.exports = __webpack_public_path__ + "static/media/switch-off.e47d69d0.svg";